/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

const useQuery = (): URLSearchParams => {
  let { search } = window?.location;
  if (!search) search = '';
  return useMemo(() => new URLSearchParams(search), [search]);
};

const useFragment = (): URLSearchParams => {
  const { hash } = window?.location;
  let search = hash || '';
  let idx = search.indexOf('?');
  if (idx == -1) idx = search.indexOf('&');
  if (idx >= 0) {
    search = search.substring(idx + 1);
  } else search = '';
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const getQueryProps = () => {
  const query: URLSearchParams = useQuery();
  const result: any = {};
  let loaded = false;
  query.forEach((value, key) => {
    result[key] = value;
    loaded = true;
  });

  const queryHash: URLSearchParams = useFragment();
  queryHash.forEach((value, key) => {
    result[key] = value;
    loaded = true;
  });

  return result;
};